/* eslint-disable @typescript-eslint/naming-convention */
import extend from 'node.extend';
import TCPlayer from 'tcplayer.js';

export const createTCPlayer = (playerId, config) => {
    const player = new TCPlayer(
        playerId,
        extend(
            {
                autoplay: true,
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight,
                controls: false, // 自定义
                x5_player: true,
                x5_type: 'h5-page',
                flash: false,
                bigPlayButton: false,
                posterImage: true,
                loop: false,
                muted: false
            },
            config
        )
    );
    if (config.url) {
        player.src(config.url);
    }
    player.volume(0.6);

    return player;
};
